export const dk = {
  bg: "#0C0F0C",
  surface: "#111512",
  panel: "#131815",
  ink: "#D0E0CC",
  inkSoft: "#8AA488",
  muted: "#486044",
  sage: "#4E8050",
  sageMid: "#5E9860",
  sageBright: "#70B872",
  border: "#182018",
  hairline: "#1E2C1E",
  glow: "rgba(78, 128, 80, 0.32)",
  glowStrong: "rgba(78, 128, 80, 0.55)",
  errorBg: "rgba(150, 40, 30, 0.14)",
  errorBorder: "#7A3028",
  errorText: "#D08070",
} as const;
